import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { YellowBrickRoadModel } from '../../../../../src/app/jobs/applicant-service/models/yellow-brick-road-model';

@Injectable({
  providedIn: 'root'
})
export class YellowBrickRoadService {
  private modelSource = new Subject<YellowBrickRoadModel>();
  private isPartOneSource = new Subject<boolean>();

  modelUpdated$ = this.modelSource.asObservable();
  isPartOneUpdated$ = this.isPartOneSource.asObservable();

  constructor() { }

  updateModel(model: YellowBrickRoadModel) {
    this.modelSource.next(model);
  }

  updateIsPartOne(isPartOne: boolean) {
    this.isPartOneSource.next(isPartOne);
  }
}
